<script lang="ts">
    import {onMount} from "svelte";
    import TabContentView from "../../../../../component/common/Tab/TabContentView.svelte";
    import {UrlUtil} from "../../../../../lib/Common/Http/UrlUtil";

    export let activeTabName;

    $: baseUrl = (() => {
        const baseUrl = window.location.origin;
        const uploadApiUrl = baseUrl + UrlUtil.createApiUrl(`/binary/access_token`);
        return uploadApiUrl;
    })();

    onMount(() => {
    });


</script>

<TabContentView tabName="ダウンロード" activeTabName={activeTabName}>
    <div class="binary-api-help-download-tab-content">
        <div>
            <div>
                スペース全体のアクセストークンを使うか、アプリごとのアクセストークンを使うか、二通りの指定方法があります。
            </div>
            <div>
                ブラウザからURLにアクセスするだけでもダウンロードできます。
            </div>
        </div>

        <div>
            <fieldset>
                <legend>アプリアクセストークン</legend>
                <div>
                    { `GET ${baseUrl}?app_access_token=[アプリアクセストークン]&unique_id=[バイナリユニークID]&file_extension=[ファイル拡張子]` }
                </div>
            </fieldset>
        </div>

        <div>
            <fieldset>
                <legend>スペースアクセストークン</legend>
                <div>
                    { `GET ${baseUrl}?space_access_token=[スペースアクセストークン]&app_unique_id=[アプリユニークID]&unique_id=[バイナリユニークID]&file_extension=[ファイル拡張子]` }
                </div>
            </fieldset>
        </div>

        <div>
            <fieldset>
                <legend>パラメーター</legend>
                <div class="param-area">
                    <table>
                        <thead>
                        <tr>
                            <th>key</th>
                            <th>説明</th>
                        </tr>
                        </thead>
                        <tbody>
                        <tr>
                            <td>unique_id</td>
                            <td>バイナリを示すユニークIDを指定してください。</td>
                        </tr>
                        <tr>
                            <td>file_extension</td>
                            <td>
                                <div>ダウンロードしたい拡張子を指定してください。ipa or aab or apk</div>
                                <div>例えば、Androidの場合、aab か apk かどちらをダウンロードしたいか明確な指定が必要です。</div>
                                <div class="thin-small-text">※アプリバイナリではなく、Unity Asset Bundle などであれば、指定は不要です</div>
                            </td>
                        </tr>
                        </tbody>
                    </table>
                </div>
            </fieldset>
        </div>

    </div>


</TabContentView>
<style lang="scss">
    .binary-api-help-download-tab-content {
        display: flex;
        flex-direction: column;
        gap: 32px;
        font-size: 0.75em;

        padding: 16px;

        .curl-command-area {
            .curl-command {
                white-space: normal;

                background-color: #000;
                color: #fff;
                padding: 0.5em;

            }
        }
    }

</style>